import { useTranslation } from "react-i18next";
import { Box, Typography, CircularProgress } from "@mui/material";

import { BranchSportIcon } from "../../assets/icons/entity-icons";
import { EntityBranchDetails } from "../../../Entity/api/types/entityBranches.types";

const SportsTab = ({
  isBranchDataLoading,
  branchData,
}: {
  isBranchDataLoading: boolean;
  branchData?: EntityBranchDetails;
}) => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEditBranch" });
  const sportsOffered = branchData?.sports;

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("sports")}</Typography>

      {isBranchDataLoading && <CircularProgress sx={styles.loading} />}
      {!isBranchDataLoading && sportsOffered && (
        <Box sx={styles.sportsGrid}>
          {sportsOffered.map((sport) => (
            <Box key={sport.sportId} sx={styles.sportItem}>
              <BranchSportIcon />
              <Typography sx={styles.sportLabel}>{sport.name}</Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default SportsTab;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "0 16px",
  },
  title: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  sportsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: "16px",
  },
  sportItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  sportLabel: {
    color: "var(--Gray-700, #344054)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
  loading: {
    margin: "50px auto",
  },
};
